var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from 'react';
var LegalContext = createContext({
    legalList: [],
    addToLegalList: function () { },
    openLegal: null,
    clearLegalList: function () { },
    handleLegalLinkClick: function () { },
    handleLegalClose: function () { },
    language: 'en',
    dictionary: {}
});
export var useLegalContext = function () { return useContext(LegalContext); };
export var ContextProvider = function (_a) {
    var children = _a.children, language = _a.language, dictionary = _a.dictionary;
    var _b = useState([]), legalList = _b[0], setLegalList = _b[1];
    var _c = useState(null), openLegal = _c[0], setOpenLegal = _c[1];
    /**
     * Click handler for each legal entry in contentful
     * @param {number} legalNumber number represent which legal will be opened.
     * @returns
     */
    var handleLegalLinkClick = function (legalNumber) { return function () { return setOpenLegal(legalNumber); }; };
    /**
     * Handler for closing the drawer.
     * @returns
     */
    var handleLegalClose = function () { return setOpenLegal(null); };
    /**
     * Function which will add legals to the list from contentful
     * @param {string} id  node id of the button from contentful
     * @param {string} triggerButtonId id of the button that trigger the drawer
     * @param {string} content content to be displayed in drawer
     */
    var addToLegalList = function (id, triggerButtonId, content) {
        setLegalList(function (prev) {
            if (!(prev === null || prev === void 0 ? void 0 : prev.some(function (legal) { return legal.id === id; }))) {
                return __spreadArray(__spreadArray([], prev, true), [{ id: id, triggerButtonId: triggerButtonId, content: content }], false);
            }
            return prev;
        });
    };
    /**
     * Clears the legal list
     */
    var clearLegalList = function () { return setLegalList([]); };
    var value = {
        legalList: legalList,
        addToLegalList: addToLegalList,
        openLegal: openLegal,
        clearLegalList: clearLegalList,
        handleLegalLinkClick: handleLegalLinkClick,
        handleLegalClose: handleLegalClose,
        language: language,
        dictionary: dictionary
    };
    return _jsx(LegalContext.Provider, { value: value, children: children });
};
export default LegalContext;
